var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpRedArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8258 10.1836C19.2609 10.7484 18.3451 10.7484 17.7802 10.1836L13.0173 5.42064L8.25436 10.1836C7.6895 10.7484 6.77367 10.7484 6.20881 10.1836C5.64394 9.6187 5.64394 8.70288 6.20881 8.13801L11.9945 2.3523C12.5594 1.78743 13.4752 1.78743 14.0401 2.3523L19.8258 8.13801C20.3907 8.70288 20.3907 9.61871 19.8258 10.1836Z",
    fill: "#B42120"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0173 25.0817C12.2185 25.0817 11.5709 24.4341 11.5709 23.6353V6.16508C11.5709 5.36624 12.2185 4.71865 13.0173 4.71865C13.8161 4.71865 14.4637 5.36624 14.4637 6.16508V23.6353C14.4637 24.4341 13.8161 25.0817 13.0173 25.0817Z",
    fill: "#B42120"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRedArrow);
export default __webpack_public_path__ + "static/media/up-red-arrow.4c5e1282.svg";
export { ForwardRef as ReactComponent };